/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AgencyOS API
 * API AgencyOS (/api/v1). Le client des apps est généré depuis ce schéma.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CommentReplyRequest,
  CommunityContent,
  CommunityContentRequest,
  CommunityLink,
  CommunityLinkRequest,
  MediaRemoveRequest,
  MediaUploadRequest,
  PaginatedCommunityContentList,
  PaginatedCommunityLinkList,
  PaginatedScheduledPostList,
  PaginatedSocialCommentList,
  PaginatedSocialSettingsList,
  PatchedCommunityContentRequest,
  PatchedCommunityLinkRequest,
  PatchedScheduledPostRequest,
  PatchedSocialSettingsRequest,
  ScheduledPost,
  ScheduledPostRequest,
  SocialComment,
  SocialCommentsListParams,
  SocialCommunitiesListParams,
  SocialCommunityContentsListParams,
  SocialPostsListParams,
  SocialSettings,
  SocialSettingsListParams
} from '.././model';

import { apiFetch } from '../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Comments queue: « À traiter », the hidden ones (and why), the AI's answers.
A person takes over at any time.
 */
export type socialCommentsListResponse200 = {
  data: PaginatedSocialCommentList
  status: 200
}
    
export type socialCommentsListResponseSuccess = (socialCommentsListResponse200) & {
  headers: Headers;
};
;

export type socialCommentsListResponse = (socialCommentsListResponseSuccess)

export const getSocialCommentsListUrl = (params?: SocialCommentsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/social/comments/?${stringifiedParams}` : `/api/v1/social/comments/`
}

export const socialCommentsList = async (params?: SocialCommentsListParams, options?: RequestInit): Promise<socialCommentsListResponse> => {
  
  return apiFetch<socialCommentsListResponse>(getSocialCommentsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSocialCommentsListQueryKey = (params?: SocialCommentsListParams,) => {
    return [
    `/api/v1/social/comments/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSocialCommentsListQueryOptions = <TData = Awaited<ReturnType<typeof socialCommentsList>>, TError = unknown>(params?: SocialCommentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialCommentsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSocialCommentsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof socialCommentsList>>> = ({ signal }) => socialCommentsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof socialCommentsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SocialCommentsListQueryResult = NonNullable<Awaited<ReturnType<typeof socialCommentsList>>>
export type SocialCommentsListQueryError = unknown


export function useSocialCommentsList<TData = Awaited<ReturnType<typeof socialCommentsList>>, TError = unknown>(
 params: undefined |  SocialCommentsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialCommentsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof socialCommentsList>>,
          TError,
          Awaited<ReturnType<typeof socialCommentsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSocialCommentsList<TData = Awaited<ReturnType<typeof socialCommentsList>>, TError = unknown>(
 params?: SocialCommentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialCommentsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof socialCommentsList>>,
          TError,
          Awaited<ReturnType<typeof socialCommentsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSocialCommentsList<TData = Awaited<ReturnType<typeof socialCommentsList>>, TError = unknown>(
 params?: SocialCommentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialCommentsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSocialCommentsList<TData = Awaited<ReturnType<typeof socialCommentsList>>, TError = unknown>(
 params?: SocialCommentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialCommentsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSocialCommentsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Comments queue: « À traiter », the hidden ones (and why), the AI's answers.
A person takes over at any time.
 */
export type socialCommentsRetrieveResponse200 = {
  data: SocialComment
  status: 200
}
    
export type socialCommentsRetrieveResponseSuccess = (socialCommentsRetrieveResponse200) & {
  headers: Headers;
};
;

export type socialCommentsRetrieveResponse = (socialCommentsRetrieveResponseSuccess)

export const getSocialCommentsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/social/comments/${id}/`
}

export const socialCommentsRetrieve = async (id: string, options?: RequestInit): Promise<socialCommentsRetrieveResponse> => {
  
  return apiFetch<socialCommentsRetrieveResponse>(getSocialCommentsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSocialCommentsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/social/comments/${id}/`
    ] as const;
    }

    
export const getSocialCommentsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof socialCommentsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialCommentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSocialCommentsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof socialCommentsRetrieve>>> = ({ signal }) => socialCommentsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof socialCommentsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SocialCommentsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof socialCommentsRetrieve>>>
export type SocialCommentsRetrieveQueryError = unknown


export function useSocialCommentsRetrieve<TData = Awaited<ReturnType<typeof socialCommentsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialCommentsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof socialCommentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof socialCommentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSocialCommentsRetrieve<TData = Awaited<ReturnType<typeof socialCommentsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialCommentsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof socialCommentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof socialCommentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSocialCommentsRetrieve<TData = Awaited<ReturnType<typeof socialCommentsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialCommentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSocialCommentsRetrieve<TData = Awaited<ReturnType<typeof socialCommentsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialCommentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSocialCommentsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Comments queue: « À traiter », the hidden ones (and why), the AI's answers.
A person takes over at any time.
 */
export type socialCommentsHideCreateResponse200 = {
  data: SocialComment
  status: 200
}
    
export type socialCommentsHideCreateResponseSuccess = (socialCommentsHideCreateResponse200) & {
  headers: Headers;
};
;

export type socialCommentsHideCreateResponse = (socialCommentsHideCreateResponseSuccess)

export const getSocialCommentsHideCreateUrl = (id: string,) => {


  

  return `/api/v1/social/comments/${id}/hide/`
}

export const socialCommentsHideCreate = async (id: string, options?: RequestInit): Promise<socialCommentsHideCreateResponse> => {
  
  return apiFetch<socialCommentsHideCreateResponse>(getSocialCommentsHideCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getSocialCommentsHideCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialCommentsHideCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof socialCommentsHideCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['socialCommentsHideCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof socialCommentsHideCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  socialCommentsHideCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SocialCommentsHideCreateMutationResult = NonNullable<Awaited<ReturnType<typeof socialCommentsHideCreate>>>
    
    export type SocialCommentsHideCreateMutationError = unknown

    export const useSocialCommentsHideCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialCommentsHideCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof socialCommentsHideCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getSocialCommentsHideCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Comments queue: « À traiter », the hidden ones (and why), the AI's answers.
A person takes over at any time.
 */
export type socialCommentsPrivateReplyCreateResponse200 = {
  data: SocialComment
  status: 200
}
    
export type socialCommentsPrivateReplyCreateResponseSuccess = (socialCommentsPrivateReplyCreateResponse200) & {
  headers: Headers;
};
;

export type socialCommentsPrivateReplyCreateResponse = (socialCommentsPrivateReplyCreateResponseSuccess)

export const getSocialCommentsPrivateReplyCreateUrl = (id: string,) => {


  

  return `/api/v1/social/comments/${id}/private-reply/`
}

export const socialCommentsPrivateReplyCreate = async (id: string,
    commentReplyRequest: CommentReplyRequest, options?: RequestInit): Promise<socialCommentsPrivateReplyCreateResponse> => {
  
  return apiFetch<socialCommentsPrivateReplyCreateResponse>(getSocialCommentsPrivateReplyCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      commentReplyRequest,)
  }
);}




export const getSocialCommentsPrivateReplyCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialCommentsPrivateReplyCreate>>, TError,{id: string;data: CommentReplyRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof socialCommentsPrivateReplyCreate>>, TError,{id: string;data: CommentReplyRequest}, TContext> => {

const mutationKey = ['socialCommentsPrivateReplyCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof socialCommentsPrivateReplyCreate>>, {id: string;data: CommentReplyRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  socialCommentsPrivateReplyCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SocialCommentsPrivateReplyCreateMutationResult = NonNullable<Awaited<ReturnType<typeof socialCommentsPrivateReplyCreate>>>
    export type SocialCommentsPrivateReplyCreateMutationBody = CommentReplyRequest
    export type SocialCommentsPrivateReplyCreateMutationError = unknown

    export const useSocialCommentsPrivateReplyCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialCommentsPrivateReplyCreate>>, TError,{id: string;data: CommentReplyRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof socialCommentsPrivateReplyCreate>>,
        TError,
        {id: string;data: CommentReplyRequest},
        TContext
      > => {

      const mutationOptions = getSocialCommentsPrivateReplyCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * A person answers publicly (takes over from the AI).
 */
export type socialCommentsReplyCreateResponse200 = {
  data: SocialComment
  status: 200
}
    
export type socialCommentsReplyCreateResponseSuccess = (socialCommentsReplyCreateResponse200) & {
  headers: Headers;
};
;

export type socialCommentsReplyCreateResponse = (socialCommentsReplyCreateResponseSuccess)

export const getSocialCommentsReplyCreateUrl = (id: string,) => {


  

  return `/api/v1/social/comments/${id}/reply/`
}

export const socialCommentsReplyCreate = async (id: string,
    commentReplyRequest: CommentReplyRequest, options?: RequestInit): Promise<socialCommentsReplyCreateResponse> => {
  
  return apiFetch<socialCommentsReplyCreateResponse>(getSocialCommentsReplyCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      commentReplyRequest,)
  }
);}




export const getSocialCommentsReplyCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialCommentsReplyCreate>>, TError,{id: string;data: CommentReplyRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof socialCommentsReplyCreate>>, TError,{id: string;data: CommentReplyRequest}, TContext> => {

const mutationKey = ['socialCommentsReplyCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof socialCommentsReplyCreate>>, {id: string;data: CommentReplyRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  socialCommentsReplyCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SocialCommentsReplyCreateMutationResult = NonNullable<Awaited<ReturnType<typeof socialCommentsReplyCreate>>>
    export type SocialCommentsReplyCreateMutationBody = CommentReplyRequest
    export type SocialCommentsReplyCreateMutationError = unknown

    export const useSocialCommentsReplyCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialCommentsReplyCreate>>, TError,{id: string;data: CommentReplyRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof socialCommentsReplyCreate>>,
        TError,
        {id: string;data: CommentReplyRequest},
        TContext
      > => {

      const mutationOptions = getSocialCommentsReplyCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Nothing more to do (handled elsewhere, e.g. on WhatsApp).
 */
export type socialCommentsResolveCreateResponse200 = {
  data: SocialComment
  status: 200
}
    
export type socialCommentsResolveCreateResponseSuccess = (socialCommentsResolveCreateResponse200) & {
  headers: Headers;
};
;

export type socialCommentsResolveCreateResponse = (socialCommentsResolveCreateResponseSuccess)

export const getSocialCommentsResolveCreateUrl = (id: string,) => {


  

  return `/api/v1/social/comments/${id}/resolve/`
}

export const socialCommentsResolveCreate = async (id: string, options?: RequestInit): Promise<socialCommentsResolveCreateResponse> => {
  
  return apiFetch<socialCommentsResolveCreateResponse>(getSocialCommentsResolveCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getSocialCommentsResolveCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialCommentsResolveCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof socialCommentsResolveCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['socialCommentsResolveCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof socialCommentsResolveCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  socialCommentsResolveCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SocialCommentsResolveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof socialCommentsResolveCreate>>>
    
    export type SocialCommentsResolveCreateMutationError = unknown

    export const useSocialCommentsResolveCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialCommentsResolveCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof socialCommentsResolveCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getSocialCommentsResolveCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Comments queue: « À traiter », the hidden ones (and why), the AI's answers.
A person takes over at any time.
 */
export type socialCommentsUnhideCreateResponse200 = {
  data: SocialComment
  status: 200
}
    
export type socialCommentsUnhideCreateResponseSuccess = (socialCommentsUnhideCreateResponse200) & {
  headers: Headers;
};
;

export type socialCommentsUnhideCreateResponse = (socialCommentsUnhideCreateResponseSuccess)

export const getSocialCommentsUnhideCreateUrl = (id: string,) => {


  

  return `/api/v1/social/comments/${id}/unhide/`
}

export const socialCommentsUnhideCreate = async (id: string, options?: RequestInit): Promise<socialCommentsUnhideCreateResponse> => {
  
  return apiFetch<socialCommentsUnhideCreateResponse>(getSocialCommentsUnhideCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getSocialCommentsUnhideCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialCommentsUnhideCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof socialCommentsUnhideCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['socialCommentsUnhideCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof socialCommentsUnhideCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  socialCommentsUnhideCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SocialCommentsUnhideCreateMutationResult = NonNullable<Awaited<ReturnType<typeof socialCommentsUnhideCreate>>>
    
    export type SocialCommentsUnhideCreateMutationError = unknown

    export const useSocialCommentsUnhideCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialCommentsUnhideCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof socialCommentsUnhideCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getSocialCommentsUnhideCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type socialCommunitiesListResponse200 = {
  data: PaginatedCommunityLinkList
  status: 200
}
    
export type socialCommunitiesListResponseSuccess = (socialCommunitiesListResponse200) & {
  headers: Headers;
};
;

export type socialCommunitiesListResponse = (socialCommunitiesListResponseSuccess)

export const getSocialCommunitiesListUrl = (params?: SocialCommunitiesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/social/communities/?${stringifiedParams}` : `/api/v1/social/communities/`
}

export const socialCommunitiesList = async (params?: SocialCommunitiesListParams, options?: RequestInit): Promise<socialCommunitiesListResponse> => {
  
  return apiFetch<socialCommunitiesListResponse>(getSocialCommunitiesListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSocialCommunitiesListQueryKey = (params?: SocialCommunitiesListParams,) => {
    return [
    `/api/v1/social/communities/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSocialCommunitiesListQueryOptions = <TData = Awaited<ReturnType<typeof socialCommunitiesList>>, TError = unknown>(params?: SocialCommunitiesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialCommunitiesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSocialCommunitiesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof socialCommunitiesList>>> = ({ signal }) => socialCommunitiesList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof socialCommunitiesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SocialCommunitiesListQueryResult = NonNullable<Awaited<ReturnType<typeof socialCommunitiesList>>>
export type SocialCommunitiesListQueryError = unknown


export function useSocialCommunitiesList<TData = Awaited<ReturnType<typeof socialCommunitiesList>>, TError = unknown>(
 params: undefined |  SocialCommunitiesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialCommunitiesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof socialCommunitiesList>>,
          TError,
          Awaited<ReturnType<typeof socialCommunitiesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSocialCommunitiesList<TData = Awaited<ReturnType<typeof socialCommunitiesList>>, TError = unknown>(
 params?: SocialCommunitiesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialCommunitiesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof socialCommunitiesList>>,
          TError,
          Awaited<ReturnType<typeof socialCommunitiesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSocialCommunitiesList<TData = Awaited<ReturnType<typeof socialCommunitiesList>>, TError = unknown>(
 params?: SocialCommunitiesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialCommunitiesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSocialCommunitiesList<TData = Awaited<ReturnType<typeof socialCommunitiesList>>, TError = unknown>(
 params?: SocialCommunitiesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialCommunitiesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSocialCommunitiesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type socialCommunitiesCreateResponse201 = {
  data: CommunityLink
  status: 201
}
    
export type socialCommunitiesCreateResponseSuccess = (socialCommunitiesCreateResponse201) & {
  headers: Headers;
};
;

export type socialCommunitiesCreateResponse = (socialCommunitiesCreateResponseSuccess)

export const getSocialCommunitiesCreateUrl = () => {


  

  return `/api/v1/social/communities/`
}

export const socialCommunitiesCreate = async (communityLinkRequest: CommunityLinkRequest, options?: RequestInit): Promise<socialCommunitiesCreateResponse> => {
  
  return apiFetch<socialCommunitiesCreateResponse>(getSocialCommunitiesCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      communityLinkRequest,)
  }
);}




export const getSocialCommunitiesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialCommunitiesCreate>>, TError,{data: CommunityLinkRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof socialCommunitiesCreate>>, TError,{data: CommunityLinkRequest}, TContext> => {

const mutationKey = ['socialCommunitiesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof socialCommunitiesCreate>>, {data: CommunityLinkRequest}> = (props) => {
          const {data} = props ?? {};

          return  socialCommunitiesCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SocialCommunitiesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof socialCommunitiesCreate>>>
    export type SocialCommunitiesCreateMutationBody = CommunityLinkRequest
    export type SocialCommunitiesCreateMutationError = unknown

    export const useSocialCommunitiesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialCommunitiesCreate>>, TError,{data: CommunityLinkRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof socialCommunitiesCreate>>,
        TError,
        {data: CommunityLinkRequest},
        TContext
      > => {

      const mutationOptions = getSocialCommunitiesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type socialCommunitiesRetrieveResponse200 = {
  data: CommunityLink
  status: 200
}
    
export type socialCommunitiesRetrieveResponseSuccess = (socialCommunitiesRetrieveResponse200) & {
  headers: Headers;
};
;

export type socialCommunitiesRetrieveResponse = (socialCommunitiesRetrieveResponseSuccess)

export const getSocialCommunitiesRetrieveUrl = (id: string,) => {


  

  return `/api/v1/social/communities/${id}/`
}

export const socialCommunitiesRetrieve = async (id: string, options?: RequestInit): Promise<socialCommunitiesRetrieveResponse> => {
  
  return apiFetch<socialCommunitiesRetrieveResponse>(getSocialCommunitiesRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSocialCommunitiesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/social/communities/${id}/`
    ] as const;
    }

    
export const getSocialCommunitiesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof socialCommunitiesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialCommunitiesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSocialCommunitiesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof socialCommunitiesRetrieve>>> = ({ signal }) => socialCommunitiesRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof socialCommunitiesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SocialCommunitiesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof socialCommunitiesRetrieve>>>
export type SocialCommunitiesRetrieveQueryError = unknown


export function useSocialCommunitiesRetrieve<TData = Awaited<ReturnType<typeof socialCommunitiesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialCommunitiesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof socialCommunitiesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof socialCommunitiesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSocialCommunitiesRetrieve<TData = Awaited<ReturnType<typeof socialCommunitiesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialCommunitiesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof socialCommunitiesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof socialCommunitiesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSocialCommunitiesRetrieve<TData = Awaited<ReturnType<typeof socialCommunitiesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialCommunitiesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSocialCommunitiesRetrieve<TData = Awaited<ReturnType<typeof socialCommunitiesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialCommunitiesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSocialCommunitiesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type socialCommunitiesUpdateResponse200 = {
  data: CommunityLink
  status: 200
}
    
export type socialCommunitiesUpdateResponseSuccess = (socialCommunitiesUpdateResponse200) & {
  headers: Headers;
};
;

export type socialCommunitiesUpdateResponse = (socialCommunitiesUpdateResponseSuccess)

export const getSocialCommunitiesUpdateUrl = (id: string,) => {


  

  return `/api/v1/social/communities/${id}/`
}

export const socialCommunitiesUpdate = async (id: string,
    communityLinkRequest: CommunityLinkRequest, options?: RequestInit): Promise<socialCommunitiesUpdateResponse> => {
  
  return apiFetch<socialCommunitiesUpdateResponse>(getSocialCommunitiesUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      communityLinkRequest,)
  }
);}




export const getSocialCommunitiesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialCommunitiesUpdate>>, TError,{id: string;data: CommunityLinkRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof socialCommunitiesUpdate>>, TError,{id: string;data: CommunityLinkRequest}, TContext> => {

const mutationKey = ['socialCommunitiesUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof socialCommunitiesUpdate>>, {id: string;data: CommunityLinkRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  socialCommunitiesUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SocialCommunitiesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof socialCommunitiesUpdate>>>
    export type SocialCommunitiesUpdateMutationBody = CommunityLinkRequest
    export type SocialCommunitiesUpdateMutationError = unknown

    export const useSocialCommunitiesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialCommunitiesUpdate>>, TError,{id: string;data: CommunityLinkRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof socialCommunitiesUpdate>>,
        TError,
        {id: string;data: CommunityLinkRequest},
        TContext
      > => {

      const mutationOptions = getSocialCommunitiesUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type socialCommunitiesPartialUpdateResponse200 = {
  data: CommunityLink
  status: 200
}
    
export type socialCommunitiesPartialUpdateResponseSuccess = (socialCommunitiesPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type socialCommunitiesPartialUpdateResponse = (socialCommunitiesPartialUpdateResponseSuccess)

export const getSocialCommunitiesPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/social/communities/${id}/`
}

export const socialCommunitiesPartialUpdate = async (id: string,
    patchedCommunityLinkRequest: PatchedCommunityLinkRequest, options?: RequestInit): Promise<socialCommunitiesPartialUpdateResponse> => {
  
  return apiFetch<socialCommunitiesPartialUpdateResponse>(getSocialCommunitiesPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedCommunityLinkRequest,)
  }
);}




export const getSocialCommunitiesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialCommunitiesPartialUpdate>>, TError,{id: string;data: PatchedCommunityLinkRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof socialCommunitiesPartialUpdate>>, TError,{id: string;data: PatchedCommunityLinkRequest}, TContext> => {

const mutationKey = ['socialCommunitiesPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof socialCommunitiesPartialUpdate>>, {id: string;data: PatchedCommunityLinkRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  socialCommunitiesPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SocialCommunitiesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof socialCommunitiesPartialUpdate>>>
    export type SocialCommunitiesPartialUpdateMutationBody = PatchedCommunityLinkRequest
    export type SocialCommunitiesPartialUpdateMutationError = unknown

    export const useSocialCommunitiesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialCommunitiesPartialUpdate>>, TError,{id: string;data: PatchedCommunityLinkRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof socialCommunitiesPartialUpdate>>,
        TError,
        {id: string;data: PatchedCommunityLinkRequest},
        TContext
      > => {

      const mutationOptions = getSocialCommunitiesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type socialCommunitiesDestroyResponse204 = {
  data: void
  status: 204
}
    
export type socialCommunitiesDestroyResponseSuccess = (socialCommunitiesDestroyResponse204) & {
  headers: Headers;
};
;

export type socialCommunitiesDestroyResponse = (socialCommunitiesDestroyResponseSuccess)

export const getSocialCommunitiesDestroyUrl = (id: string,) => {


  

  return `/api/v1/social/communities/${id}/`
}

export const socialCommunitiesDestroy = async (id: string, options?: RequestInit): Promise<socialCommunitiesDestroyResponse> => {
  
  return apiFetch<socialCommunitiesDestroyResponse>(getSocialCommunitiesDestroyUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getSocialCommunitiesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialCommunitiesDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof socialCommunitiesDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['socialCommunitiesDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof socialCommunitiesDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  socialCommunitiesDestroy(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SocialCommunitiesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof socialCommunitiesDestroy>>>
    
    export type SocialCommunitiesDestroyMutationError = unknown

    export const useSocialCommunitiesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialCommunitiesDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof socialCommunitiesDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getSocialCommunitiesDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Content prepared for groups and communities: copied or shared by hand (no Meta API).
 */
export type socialCommunityContentsListResponse200 = {
  data: PaginatedCommunityContentList
  status: 200
}
    
export type socialCommunityContentsListResponseSuccess = (socialCommunityContentsListResponse200) & {
  headers: Headers;
};
;

export type socialCommunityContentsListResponse = (socialCommunityContentsListResponseSuccess)

export const getSocialCommunityContentsListUrl = (params?: SocialCommunityContentsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/social/community-contents/?${stringifiedParams}` : `/api/v1/social/community-contents/`
}

export const socialCommunityContentsList = async (params?: SocialCommunityContentsListParams, options?: RequestInit): Promise<socialCommunityContentsListResponse> => {
  
  return apiFetch<socialCommunityContentsListResponse>(getSocialCommunityContentsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSocialCommunityContentsListQueryKey = (params?: SocialCommunityContentsListParams,) => {
    return [
    `/api/v1/social/community-contents/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSocialCommunityContentsListQueryOptions = <TData = Awaited<ReturnType<typeof socialCommunityContentsList>>, TError = unknown>(params?: SocialCommunityContentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialCommunityContentsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSocialCommunityContentsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof socialCommunityContentsList>>> = ({ signal }) => socialCommunityContentsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof socialCommunityContentsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SocialCommunityContentsListQueryResult = NonNullable<Awaited<ReturnType<typeof socialCommunityContentsList>>>
export type SocialCommunityContentsListQueryError = unknown


export function useSocialCommunityContentsList<TData = Awaited<ReturnType<typeof socialCommunityContentsList>>, TError = unknown>(
 params: undefined |  SocialCommunityContentsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialCommunityContentsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof socialCommunityContentsList>>,
          TError,
          Awaited<ReturnType<typeof socialCommunityContentsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSocialCommunityContentsList<TData = Awaited<ReturnType<typeof socialCommunityContentsList>>, TError = unknown>(
 params?: SocialCommunityContentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialCommunityContentsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof socialCommunityContentsList>>,
          TError,
          Awaited<ReturnType<typeof socialCommunityContentsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSocialCommunityContentsList<TData = Awaited<ReturnType<typeof socialCommunityContentsList>>, TError = unknown>(
 params?: SocialCommunityContentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialCommunityContentsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSocialCommunityContentsList<TData = Awaited<ReturnType<typeof socialCommunityContentsList>>, TError = unknown>(
 params?: SocialCommunityContentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialCommunityContentsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSocialCommunityContentsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Content prepared for groups and communities: copied or shared by hand (no Meta API).
 */
export type socialCommunityContentsCreateResponse201 = {
  data: CommunityContent
  status: 201
}
    
export type socialCommunityContentsCreateResponseSuccess = (socialCommunityContentsCreateResponse201) & {
  headers: Headers;
};
;

export type socialCommunityContentsCreateResponse = (socialCommunityContentsCreateResponseSuccess)

export const getSocialCommunityContentsCreateUrl = () => {


  

  return `/api/v1/social/community-contents/`
}

export const socialCommunityContentsCreate = async (communityContentRequest: CommunityContentRequest, options?: RequestInit): Promise<socialCommunityContentsCreateResponse> => {
  
  return apiFetch<socialCommunityContentsCreateResponse>(getSocialCommunityContentsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      communityContentRequest,)
  }
);}




export const getSocialCommunityContentsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialCommunityContentsCreate>>, TError,{data: CommunityContentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof socialCommunityContentsCreate>>, TError,{data: CommunityContentRequest}, TContext> => {

const mutationKey = ['socialCommunityContentsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof socialCommunityContentsCreate>>, {data: CommunityContentRequest}> = (props) => {
          const {data} = props ?? {};

          return  socialCommunityContentsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SocialCommunityContentsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof socialCommunityContentsCreate>>>
    export type SocialCommunityContentsCreateMutationBody = CommunityContentRequest
    export type SocialCommunityContentsCreateMutationError = unknown

    export const useSocialCommunityContentsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialCommunityContentsCreate>>, TError,{data: CommunityContentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof socialCommunityContentsCreate>>,
        TError,
        {data: CommunityContentRequest},
        TContext
      > => {

      const mutationOptions = getSocialCommunityContentsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Content prepared for groups and communities: copied or shared by hand (no Meta API).
 */
export type socialCommunityContentsRetrieveResponse200 = {
  data: CommunityContent
  status: 200
}
    
export type socialCommunityContentsRetrieveResponseSuccess = (socialCommunityContentsRetrieveResponse200) & {
  headers: Headers;
};
;

export type socialCommunityContentsRetrieveResponse = (socialCommunityContentsRetrieveResponseSuccess)

export const getSocialCommunityContentsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/social/community-contents/${id}/`
}

export const socialCommunityContentsRetrieve = async (id: string, options?: RequestInit): Promise<socialCommunityContentsRetrieveResponse> => {
  
  return apiFetch<socialCommunityContentsRetrieveResponse>(getSocialCommunityContentsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSocialCommunityContentsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/social/community-contents/${id}/`
    ] as const;
    }

    
export const getSocialCommunityContentsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof socialCommunityContentsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialCommunityContentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSocialCommunityContentsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof socialCommunityContentsRetrieve>>> = ({ signal }) => socialCommunityContentsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof socialCommunityContentsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SocialCommunityContentsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof socialCommunityContentsRetrieve>>>
export type SocialCommunityContentsRetrieveQueryError = unknown


export function useSocialCommunityContentsRetrieve<TData = Awaited<ReturnType<typeof socialCommunityContentsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialCommunityContentsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof socialCommunityContentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof socialCommunityContentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSocialCommunityContentsRetrieve<TData = Awaited<ReturnType<typeof socialCommunityContentsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialCommunityContentsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof socialCommunityContentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof socialCommunityContentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSocialCommunityContentsRetrieve<TData = Awaited<ReturnType<typeof socialCommunityContentsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialCommunityContentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSocialCommunityContentsRetrieve<TData = Awaited<ReturnType<typeof socialCommunityContentsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialCommunityContentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSocialCommunityContentsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Content prepared for groups and communities: copied or shared by hand (no Meta API).
 */
export type socialCommunityContentsUpdateResponse200 = {
  data: CommunityContent
  status: 200
}
    
export type socialCommunityContentsUpdateResponseSuccess = (socialCommunityContentsUpdateResponse200) & {
  headers: Headers;
};
;

export type socialCommunityContentsUpdateResponse = (socialCommunityContentsUpdateResponseSuccess)

export const getSocialCommunityContentsUpdateUrl = (id: string,) => {


  

  return `/api/v1/social/community-contents/${id}/`
}

export const socialCommunityContentsUpdate = async (id: string,
    communityContentRequest: CommunityContentRequest, options?: RequestInit): Promise<socialCommunityContentsUpdateResponse> => {
  
  return apiFetch<socialCommunityContentsUpdateResponse>(getSocialCommunityContentsUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      communityContentRequest,)
  }
);}




export const getSocialCommunityContentsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialCommunityContentsUpdate>>, TError,{id: string;data: CommunityContentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof socialCommunityContentsUpdate>>, TError,{id: string;data: CommunityContentRequest}, TContext> => {

const mutationKey = ['socialCommunityContentsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof socialCommunityContentsUpdate>>, {id: string;data: CommunityContentRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  socialCommunityContentsUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SocialCommunityContentsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof socialCommunityContentsUpdate>>>
    export type SocialCommunityContentsUpdateMutationBody = CommunityContentRequest
    export type SocialCommunityContentsUpdateMutationError = unknown

    export const useSocialCommunityContentsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialCommunityContentsUpdate>>, TError,{id: string;data: CommunityContentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof socialCommunityContentsUpdate>>,
        TError,
        {id: string;data: CommunityContentRequest},
        TContext
      > => {

      const mutationOptions = getSocialCommunityContentsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Content prepared for groups and communities: copied or shared by hand (no Meta API).
 */
export type socialCommunityContentsPartialUpdateResponse200 = {
  data: CommunityContent
  status: 200
}
    
export type socialCommunityContentsPartialUpdateResponseSuccess = (socialCommunityContentsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type socialCommunityContentsPartialUpdateResponse = (socialCommunityContentsPartialUpdateResponseSuccess)

export const getSocialCommunityContentsPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/social/community-contents/${id}/`
}

export const socialCommunityContentsPartialUpdate = async (id: string,
    patchedCommunityContentRequest: PatchedCommunityContentRequest, options?: RequestInit): Promise<socialCommunityContentsPartialUpdateResponse> => {
  
  return apiFetch<socialCommunityContentsPartialUpdateResponse>(getSocialCommunityContentsPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedCommunityContentRequest,)
  }
);}




export const getSocialCommunityContentsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialCommunityContentsPartialUpdate>>, TError,{id: string;data: PatchedCommunityContentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof socialCommunityContentsPartialUpdate>>, TError,{id: string;data: PatchedCommunityContentRequest}, TContext> => {

const mutationKey = ['socialCommunityContentsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof socialCommunityContentsPartialUpdate>>, {id: string;data: PatchedCommunityContentRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  socialCommunityContentsPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SocialCommunityContentsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof socialCommunityContentsPartialUpdate>>>
    export type SocialCommunityContentsPartialUpdateMutationBody = PatchedCommunityContentRequest
    export type SocialCommunityContentsPartialUpdateMutationError = unknown

    export const useSocialCommunityContentsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialCommunityContentsPartialUpdate>>, TError,{id: string;data: PatchedCommunityContentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof socialCommunityContentsPartialUpdate>>,
        TError,
        {id: string;data: PatchedCommunityContentRequest},
        TContext
      > => {

      const mutationOptions = getSocialCommunityContentsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Content prepared for groups and communities: copied or shared by hand (no Meta API).
 */
export type socialCommunityContentsDestroyResponse204 = {
  data: void
  status: 204
}
    
export type socialCommunityContentsDestroyResponseSuccess = (socialCommunityContentsDestroyResponse204) & {
  headers: Headers;
};
;

export type socialCommunityContentsDestroyResponse = (socialCommunityContentsDestroyResponseSuccess)

export const getSocialCommunityContentsDestroyUrl = (id: string,) => {


  

  return `/api/v1/social/community-contents/${id}/`
}

export const socialCommunityContentsDestroy = async (id: string, options?: RequestInit): Promise<socialCommunityContentsDestroyResponse> => {
  
  return apiFetch<socialCommunityContentsDestroyResponse>(getSocialCommunityContentsDestroyUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getSocialCommunityContentsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialCommunityContentsDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof socialCommunityContentsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['socialCommunityContentsDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof socialCommunityContentsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  socialCommunityContentsDestroy(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SocialCommunityContentsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof socialCommunityContentsDestroy>>>
    
    export type SocialCommunityContentsDestroyMutationError = unknown

    export const useSocialCommunityContentsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialCommunityContentsDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof socialCommunityContentsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getSocialCommunityContentsDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * A person copied or shared it: counted, for the history.
 */
export type socialCommunityContentsSharedCreateResponse200 = {
  data: CommunityContent
  status: 200
}
    
export type socialCommunityContentsSharedCreateResponseSuccess = (socialCommunityContentsSharedCreateResponse200) & {
  headers: Headers;
};
;

export type socialCommunityContentsSharedCreateResponse = (socialCommunityContentsSharedCreateResponseSuccess)

export const getSocialCommunityContentsSharedCreateUrl = (id: string,) => {


  

  return `/api/v1/social/community-contents/${id}/shared/`
}

export const socialCommunityContentsSharedCreate = async (id: string, options?: RequestInit): Promise<socialCommunityContentsSharedCreateResponse> => {
  
  return apiFetch<socialCommunityContentsSharedCreateResponse>(getSocialCommunityContentsSharedCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getSocialCommunityContentsSharedCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialCommunityContentsSharedCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof socialCommunityContentsSharedCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['socialCommunityContentsSharedCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof socialCommunityContentsSharedCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  socialCommunityContentsSharedCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SocialCommunityContentsSharedCreateMutationResult = NonNullable<Awaited<ReturnType<typeof socialCommunityContentsSharedCreate>>>
    
    export type SocialCommunityContentsSharedCreateMutationError = unknown

    export const useSocialCommunityContentsSharedCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialCommunityContentsSharedCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof socialCommunityContentsSharedCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getSocialCommunityContentsSharedCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Content prepared for groups and communities: copied or shared by hand (no Meta API).
 */
export type socialCommunityContentsUploadCreateResponse200 = {
  data: CommunityContent
  status: 200
}
    
export type socialCommunityContentsUploadCreateResponseSuccess = (socialCommunityContentsUploadCreateResponse200) & {
  headers: Headers;
};
;

export type socialCommunityContentsUploadCreateResponse = (socialCommunityContentsUploadCreateResponseSuccess)

export const getSocialCommunityContentsUploadCreateUrl = (id: string,) => {


  

  return `/api/v1/social/community-contents/${id}/upload/`
}

export const socialCommunityContentsUploadCreate = async (id: string,
    mediaUploadRequest: MediaUploadRequest, options?: RequestInit): Promise<socialCommunityContentsUploadCreateResponse> => {
    const formData = new FormData();
formData.append(`file`, mediaUploadRequest.file)

  return apiFetch<socialCommunityContentsUploadCreateResponse>(getSocialCommunityContentsUploadCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}




export const getSocialCommunityContentsUploadCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialCommunityContentsUploadCreate>>, TError,{id: string;data: MediaUploadRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof socialCommunityContentsUploadCreate>>, TError,{id: string;data: MediaUploadRequest}, TContext> => {

const mutationKey = ['socialCommunityContentsUploadCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof socialCommunityContentsUploadCreate>>, {id: string;data: MediaUploadRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  socialCommunityContentsUploadCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SocialCommunityContentsUploadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof socialCommunityContentsUploadCreate>>>
    export type SocialCommunityContentsUploadCreateMutationBody = MediaUploadRequest
    export type SocialCommunityContentsUploadCreateMutationError = unknown

    export const useSocialCommunityContentsUploadCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialCommunityContentsUploadCreate>>, TError,{id: string;data: MediaUploadRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof socialCommunityContentsUploadCreate>>,
        TError,
        {id: string;data: MediaUploadRequest},
        TContext
      > => {

      const mutationOptions = getSocialCommunityContentsUploadCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Editorial calendar: the posts of a period (?start=&end=), then create and schedule.
 */
export type socialPostsListResponse200 = {
  data: PaginatedScheduledPostList
  status: 200
}
    
export type socialPostsListResponseSuccess = (socialPostsListResponse200) & {
  headers: Headers;
};
;

export type socialPostsListResponse = (socialPostsListResponseSuccess)

export const getSocialPostsListUrl = (params?: SocialPostsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/social/posts/?${stringifiedParams}` : `/api/v1/social/posts/`
}

export const socialPostsList = async (params?: SocialPostsListParams, options?: RequestInit): Promise<socialPostsListResponse> => {
  
  return apiFetch<socialPostsListResponse>(getSocialPostsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSocialPostsListQueryKey = (params?: SocialPostsListParams,) => {
    return [
    `/api/v1/social/posts/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSocialPostsListQueryOptions = <TData = Awaited<ReturnType<typeof socialPostsList>>, TError = unknown>(params?: SocialPostsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialPostsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSocialPostsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof socialPostsList>>> = ({ signal }) => socialPostsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof socialPostsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SocialPostsListQueryResult = NonNullable<Awaited<ReturnType<typeof socialPostsList>>>
export type SocialPostsListQueryError = unknown


export function useSocialPostsList<TData = Awaited<ReturnType<typeof socialPostsList>>, TError = unknown>(
 params: undefined |  SocialPostsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialPostsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof socialPostsList>>,
          TError,
          Awaited<ReturnType<typeof socialPostsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSocialPostsList<TData = Awaited<ReturnType<typeof socialPostsList>>, TError = unknown>(
 params?: SocialPostsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialPostsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof socialPostsList>>,
          TError,
          Awaited<ReturnType<typeof socialPostsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSocialPostsList<TData = Awaited<ReturnType<typeof socialPostsList>>, TError = unknown>(
 params?: SocialPostsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialPostsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSocialPostsList<TData = Awaited<ReturnType<typeof socialPostsList>>, TError = unknown>(
 params?: SocialPostsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialPostsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSocialPostsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Editorial calendar: the posts of a period (?start=&end=), then create and schedule.
 */
export type socialPostsCreateResponse201 = {
  data: ScheduledPost
  status: 201
}
    
export type socialPostsCreateResponseSuccess = (socialPostsCreateResponse201) & {
  headers: Headers;
};
;

export type socialPostsCreateResponse = (socialPostsCreateResponseSuccess)

export const getSocialPostsCreateUrl = () => {


  

  return `/api/v1/social/posts/`
}

export const socialPostsCreate = async (scheduledPostRequest: ScheduledPostRequest, options?: RequestInit): Promise<socialPostsCreateResponse> => {
  
  return apiFetch<socialPostsCreateResponse>(getSocialPostsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      scheduledPostRequest,)
  }
);}




export const getSocialPostsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialPostsCreate>>, TError,{data: ScheduledPostRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof socialPostsCreate>>, TError,{data: ScheduledPostRequest}, TContext> => {

const mutationKey = ['socialPostsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof socialPostsCreate>>, {data: ScheduledPostRequest}> = (props) => {
          const {data} = props ?? {};

          return  socialPostsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SocialPostsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof socialPostsCreate>>>
    export type SocialPostsCreateMutationBody = ScheduledPostRequest
    export type SocialPostsCreateMutationError = unknown

    export const useSocialPostsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialPostsCreate>>, TError,{data: ScheduledPostRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof socialPostsCreate>>,
        TError,
        {data: ScheduledPostRequest},
        TContext
      > => {

      const mutationOptions = getSocialPostsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Editorial calendar: the posts of a period (?start=&end=), then create and schedule.
 */
export type socialPostsRetrieveResponse200 = {
  data: ScheduledPost
  status: 200
}
    
export type socialPostsRetrieveResponseSuccess = (socialPostsRetrieveResponse200) & {
  headers: Headers;
};
;

export type socialPostsRetrieveResponse = (socialPostsRetrieveResponseSuccess)

export const getSocialPostsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/social/posts/${id}/`
}

export const socialPostsRetrieve = async (id: string, options?: RequestInit): Promise<socialPostsRetrieveResponse> => {
  
  return apiFetch<socialPostsRetrieveResponse>(getSocialPostsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSocialPostsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/social/posts/${id}/`
    ] as const;
    }

    
export const getSocialPostsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof socialPostsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialPostsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSocialPostsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof socialPostsRetrieve>>> = ({ signal }) => socialPostsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof socialPostsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SocialPostsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof socialPostsRetrieve>>>
export type SocialPostsRetrieveQueryError = unknown


export function useSocialPostsRetrieve<TData = Awaited<ReturnType<typeof socialPostsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialPostsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof socialPostsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof socialPostsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSocialPostsRetrieve<TData = Awaited<ReturnType<typeof socialPostsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialPostsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof socialPostsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof socialPostsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSocialPostsRetrieve<TData = Awaited<ReturnType<typeof socialPostsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialPostsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSocialPostsRetrieve<TData = Awaited<ReturnType<typeof socialPostsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialPostsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSocialPostsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Editorial calendar: the posts of a period (?start=&end=), then create and schedule.
 */
export type socialPostsUpdateResponse200 = {
  data: ScheduledPost
  status: 200
}
    
export type socialPostsUpdateResponseSuccess = (socialPostsUpdateResponse200) & {
  headers: Headers;
};
;

export type socialPostsUpdateResponse = (socialPostsUpdateResponseSuccess)

export const getSocialPostsUpdateUrl = (id: string,) => {


  

  return `/api/v1/social/posts/${id}/`
}

export const socialPostsUpdate = async (id: string,
    scheduledPostRequest: ScheduledPostRequest, options?: RequestInit): Promise<socialPostsUpdateResponse> => {
  
  return apiFetch<socialPostsUpdateResponse>(getSocialPostsUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      scheduledPostRequest,)
  }
);}




export const getSocialPostsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialPostsUpdate>>, TError,{id: string;data: ScheduledPostRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof socialPostsUpdate>>, TError,{id: string;data: ScheduledPostRequest}, TContext> => {

const mutationKey = ['socialPostsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof socialPostsUpdate>>, {id: string;data: ScheduledPostRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  socialPostsUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SocialPostsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof socialPostsUpdate>>>
    export type SocialPostsUpdateMutationBody = ScheduledPostRequest
    export type SocialPostsUpdateMutationError = unknown

    export const useSocialPostsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialPostsUpdate>>, TError,{id: string;data: ScheduledPostRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof socialPostsUpdate>>,
        TError,
        {id: string;data: ScheduledPostRequest},
        TContext
      > => {

      const mutationOptions = getSocialPostsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Editorial calendar: the posts of a period (?start=&end=), then create and schedule.
 */
export type socialPostsPartialUpdateResponse200 = {
  data: ScheduledPost
  status: 200
}
    
export type socialPostsPartialUpdateResponseSuccess = (socialPostsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type socialPostsPartialUpdateResponse = (socialPostsPartialUpdateResponseSuccess)

export const getSocialPostsPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/social/posts/${id}/`
}

export const socialPostsPartialUpdate = async (id: string,
    patchedScheduledPostRequest: PatchedScheduledPostRequest, options?: RequestInit): Promise<socialPostsPartialUpdateResponse> => {
  
  return apiFetch<socialPostsPartialUpdateResponse>(getSocialPostsPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedScheduledPostRequest,)
  }
);}




export const getSocialPostsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialPostsPartialUpdate>>, TError,{id: string;data: PatchedScheduledPostRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof socialPostsPartialUpdate>>, TError,{id: string;data: PatchedScheduledPostRequest}, TContext> => {

const mutationKey = ['socialPostsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof socialPostsPartialUpdate>>, {id: string;data: PatchedScheduledPostRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  socialPostsPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SocialPostsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof socialPostsPartialUpdate>>>
    export type SocialPostsPartialUpdateMutationBody = PatchedScheduledPostRequest
    export type SocialPostsPartialUpdateMutationError = unknown

    export const useSocialPostsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialPostsPartialUpdate>>, TError,{id: string;data: PatchedScheduledPostRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof socialPostsPartialUpdate>>,
        TError,
        {id: string;data: PatchedScheduledPostRequest},
        TContext
      > => {

      const mutationOptions = getSocialPostsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Editorial calendar: the posts of a period (?start=&end=), then create and schedule.
 */
export type socialPostsDestroyResponse204 = {
  data: void
  status: 204
}
    
export type socialPostsDestroyResponseSuccess = (socialPostsDestroyResponse204) & {
  headers: Headers;
};
;

export type socialPostsDestroyResponse = (socialPostsDestroyResponseSuccess)

export const getSocialPostsDestroyUrl = (id: string,) => {


  

  return `/api/v1/social/posts/${id}/`
}

export const socialPostsDestroy = async (id: string, options?: RequestInit): Promise<socialPostsDestroyResponse> => {
  
  return apiFetch<socialPostsDestroyResponse>(getSocialPostsDestroyUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getSocialPostsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialPostsDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof socialPostsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['socialPostsDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof socialPostsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  socialPostsDestroy(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SocialPostsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof socialPostsDestroy>>>
    
    export type SocialPostsDestroyMutationError = unknown

    export const useSocialPostsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialPostsDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof socialPostsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getSocialPostsDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Editorial calendar: the posts of a period (?start=&end=), then create and schedule.
 */
export type socialPostsMediaCreateResponse201 = {
  data: ScheduledPost
  status: 201
}
    
export type socialPostsMediaCreateResponseSuccess = (socialPostsMediaCreateResponse201) & {
  headers: Headers;
};
;

export type socialPostsMediaCreateResponse = (socialPostsMediaCreateResponseSuccess)

export const getSocialPostsMediaCreateUrl = (id: string,) => {


  

  return `/api/v1/social/posts/${id}/media/`
}

export const socialPostsMediaCreate = async (id: string,
    mediaUploadRequest: MediaUploadRequest, options?: RequestInit): Promise<socialPostsMediaCreateResponse> => {
    const formData = new FormData();
formData.append(`file`, mediaUploadRequest.file)

  return apiFetch<socialPostsMediaCreateResponse>(getSocialPostsMediaCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}




export const getSocialPostsMediaCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialPostsMediaCreate>>, TError,{id: string;data: MediaUploadRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof socialPostsMediaCreate>>, TError,{id: string;data: MediaUploadRequest}, TContext> => {

const mutationKey = ['socialPostsMediaCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof socialPostsMediaCreate>>, {id: string;data: MediaUploadRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  socialPostsMediaCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SocialPostsMediaCreateMutationResult = NonNullable<Awaited<ReturnType<typeof socialPostsMediaCreate>>>
    export type SocialPostsMediaCreateMutationBody = MediaUploadRequest
    export type SocialPostsMediaCreateMutationError = unknown

    export const useSocialPostsMediaCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialPostsMediaCreate>>, TError,{id: string;data: MediaUploadRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof socialPostsMediaCreate>>,
        TError,
        {id: string;data: MediaUploadRequest},
        TContext
      > => {

      const mutationOptions = getSocialPostsMediaCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Scheduled for now: beat publishes it within a minute.
 */
export type socialPostsPublishNowCreateResponse200 = {
  data: ScheduledPost
  status: 200
}
    
export type socialPostsPublishNowCreateResponseSuccess = (socialPostsPublishNowCreateResponse200) & {
  headers: Headers;
};
;

export type socialPostsPublishNowCreateResponse = (socialPostsPublishNowCreateResponseSuccess)

export const getSocialPostsPublishNowCreateUrl = (id: string,) => {


  

  return `/api/v1/social/posts/${id}/publish-now/`
}

export const socialPostsPublishNowCreate = async (id: string, options?: RequestInit): Promise<socialPostsPublishNowCreateResponse> => {
  
  return apiFetch<socialPostsPublishNowCreateResponse>(getSocialPostsPublishNowCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getSocialPostsPublishNowCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialPostsPublishNowCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof socialPostsPublishNowCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['socialPostsPublishNowCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof socialPostsPublishNowCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  socialPostsPublishNowCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SocialPostsPublishNowCreateMutationResult = NonNullable<Awaited<ReturnType<typeof socialPostsPublishNowCreate>>>
    
    export type SocialPostsPublishNowCreateMutationError = unknown

    export const useSocialPostsPublishNowCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialPostsPublishNowCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof socialPostsPublishNowCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getSocialPostsPublishNowCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Editorial calendar: the posts of a period (?start=&end=), then create and schedule.
 */
export type socialPostsRemoveMediaCreateResponse200 = {
  data: ScheduledPost
  status: 200
}
    
export type socialPostsRemoveMediaCreateResponseSuccess = (socialPostsRemoveMediaCreateResponse200) & {
  headers: Headers;
};
;

export type socialPostsRemoveMediaCreateResponse = (socialPostsRemoveMediaCreateResponseSuccess)

export const getSocialPostsRemoveMediaCreateUrl = (id: string,) => {


  

  return `/api/v1/social/posts/${id}/remove-media/`
}

export const socialPostsRemoveMediaCreate = async (id: string,
    mediaRemoveRequest: MediaRemoveRequest, options?: RequestInit): Promise<socialPostsRemoveMediaCreateResponse> => {
  
  return apiFetch<socialPostsRemoveMediaCreateResponse>(getSocialPostsRemoveMediaCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      mediaRemoveRequest,)
  }
);}




export const getSocialPostsRemoveMediaCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialPostsRemoveMediaCreate>>, TError,{id: string;data: MediaRemoveRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof socialPostsRemoveMediaCreate>>, TError,{id: string;data: MediaRemoveRequest}, TContext> => {

const mutationKey = ['socialPostsRemoveMediaCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof socialPostsRemoveMediaCreate>>, {id: string;data: MediaRemoveRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  socialPostsRemoveMediaCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SocialPostsRemoveMediaCreateMutationResult = NonNullable<Awaited<ReturnType<typeof socialPostsRemoveMediaCreate>>>
    export type SocialPostsRemoveMediaCreateMutationBody = MediaRemoveRequest
    export type SocialPostsRemoveMediaCreateMutationError = unknown

    export const useSocialPostsRemoveMediaCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialPostsRemoveMediaCreate>>, TError,{id: string;data: MediaRemoveRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof socialPostsRemoveMediaCreate>>,
        TError,
        {id: string;data: MediaRemoveRequest},
        TContext
      > => {

      const mutationOptions = getSocialPostsRemoveMediaCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Draft (or failed) → scheduled: published by beat at its time.
 */
export type socialPostsScheduleCreateResponse200 = {
  data: ScheduledPost
  status: 200
}
    
export type socialPostsScheduleCreateResponseSuccess = (socialPostsScheduleCreateResponse200) & {
  headers: Headers;
};
;

export type socialPostsScheduleCreateResponse = (socialPostsScheduleCreateResponseSuccess)

export const getSocialPostsScheduleCreateUrl = (id: string,) => {


  

  return `/api/v1/social/posts/${id}/schedule/`
}

export const socialPostsScheduleCreate = async (id: string, options?: RequestInit): Promise<socialPostsScheduleCreateResponse> => {
  
  return apiFetch<socialPostsScheduleCreateResponse>(getSocialPostsScheduleCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getSocialPostsScheduleCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialPostsScheduleCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof socialPostsScheduleCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['socialPostsScheduleCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof socialPostsScheduleCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  socialPostsScheduleCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SocialPostsScheduleCreateMutationResult = NonNullable<Awaited<ReturnType<typeof socialPostsScheduleCreate>>>
    
    export type SocialPostsScheduleCreateMutationError = unknown

    export const useSocialPostsScheduleCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialPostsScheduleCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof socialPostsScheduleCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getSocialPostsScheduleCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Editorial calendar: the posts of a period (?start=&end=), then create and schedule.
 */
export type socialPostsUnscheduleCreateResponse200 = {
  data: ScheduledPost
  status: 200
}
    
export type socialPostsUnscheduleCreateResponseSuccess = (socialPostsUnscheduleCreateResponse200) & {
  headers: Headers;
};
;

export type socialPostsUnscheduleCreateResponse = (socialPostsUnscheduleCreateResponseSuccess)

export const getSocialPostsUnscheduleCreateUrl = (id: string,) => {


  

  return `/api/v1/social/posts/${id}/unschedule/`
}

export const socialPostsUnscheduleCreate = async (id: string, options?: RequestInit): Promise<socialPostsUnscheduleCreateResponse> => {
  
  return apiFetch<socialPostsUnscheduleCreateResponse>(getSocialPostsUnscheduleCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getSocialPostsUnscheduleCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialPostsUnscheduleCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof socialPostsUnscheduleCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['socialPostsUnscheduleCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof socialPostsUnscheduleCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  socialPostsUnscheduleCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SocialPostsUnscheduleCreateMutationResult = NonNullable<Awaited<ReturnType<typeof socialPostsUnscheduleCreate>>>
    
    export type SocialPostsUnscheduleCreateMutationError = unknown

    export const useSocialPostsUnscheduleCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialPostsUnscheduleCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof socialPostsUnscheduleCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getSocialPostsUnscheduleCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type socialSettingsListResponse200 = {
  data: PaginatedSocialSettingsList
  status: 200
}
    
export type socialSettingsListResponseSuccess = (socialSettingsListResponse200) & {
  headers: Headers;
};
;

export type socialSettingsListResponse = (socialSettingsListResponseSuccess)

export const getSocialSettingsListUrl = (params?: SocialSettingsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/social/settings/?${stringifiedParams}` : `/api/v1/social/settings/`
}

export const socialSettingsList = async (params?: SocialSettingsListParams, options?: RequestInit): Promise<socialSettingsListResponse> => {
  
  return apiFetch<socialSettingsListResponse>(getSocialSettingsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSocialSettingsListQueryKey = (params?: SocialSettingsListParams,) => {
    return [
    `/api/v1/social/settings/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSocialSettingsListQueryOptions = <TData = Awaited<ReturnType<typeof socialSettingsList>>, TError = unknown>(params?: SocialSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialSettingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSocialSettingsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof socialSettingsList>>> = ({ signal }) => socialSettingsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof socialSettingsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SocialSettingsListQueryResult = NonNullable<Awaited<ReturnType<typeof socialSettingsList>>>
export type SocialSettingsListQueryError = unknown


export function useSocialSettingsList<TData = Awaited<ReturnType<typeof socialSettingsList>>, TError = unknown>(
 params: undefined |  SocialSettingsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialSettingsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof socialSettingsList>>,
          TError,
          Awaited<ReturnType<typeof socialSettingsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSocialSettingsList<TData = Awaited<ReturnType<typeof socialSettingsList>>, TError = unknown>(
 params?: SocialSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialSettingsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof socialSettingsList>>,
          TError,
          Awaited<ReturnType<typeof socialSettingsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSocialSettingsList<TData = Awaited<ReturnType<typeof socialSettingsList>>, TError = unknown>(
 params?: SocialSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialSettingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSocialSettingsList<TData = Awaited<ReturnType<typeof socialSettingsList>>, TError = unknown>(
 params?: SocialSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialSettingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSocialSettingsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type socialSettingsRetrieveResponse200 = {
  data: SocialSettings
  status: 200
}
    
export type socialSettingsRetrieveResponseSuccess = (socialSettingsRetrieveResponse200) & {
  headers: Headers;
};
;

export type socialSettingsRetrieveResponse = (socialSettingsRetrieveResponseSuccess)

export const getSocialSettingsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/social/settings/${id}/`
}

export const socialSettingsRetrieve = async (id: string, options?: RequestInit): Promise<socialSettingsRetrieveResponse> => {
  
  return apiFetch<socialSettingsRetrieveResponse>(getSocialSettingsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSocialSettingsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/social/settings/${id}/`
    ] as const;
    }

    
export const getSocialSettingsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof socialSettingsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSocialSettingsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof socialSettingsRetrieve>>> = ({ signal }) => socialSettingsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof socialSettingsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SocialSettingsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof socialSettingsRetrieve>>>
export type SocialSettingsRetrieveQueryError = unknown


export function useSocialSettingsRetrieve<TData = Awaited<ReturnType<typeof socialSettingsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialSettingsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof socialSettingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof socialSettingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSocialSettingsRetrieve<TData = Awaited<ReturnType<typeof socialSettingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialSettingsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof socialSettingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof socialSettingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSocialSettingsRetrieve<TData = Awaited<ReturnType<typeof socialSettingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSocialSettingsRetrieve<TData = Awaited<ReturnType<typeof socialSettingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof socialSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSocialSettingsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type socialSettingsPartialUpdateResponse200 = {
  data: SocialSettings
  status: 200
}
    
export type socialSettingsPartialUpdateResponseSuccess = (socialSettingsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type socialSettingsPartialUpdateResponse = (socialSettingsPartialUpdateResponseSuccess)

export const getSocialSettingsPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/social/settings/${id}/`
}

export const socialSettingsPartialUpdate = async (id: string,
    patchedSocialSettingsRequest: PatchedSocialSettingsRequest, options?: RequestInit): Promise<socialSettingsPartialUpdateResponse> => {
  
  return apiFetch<socialSettingsPartialUpdateResponse>(getSocialSettingsPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedSocialSettingsRequest,)
  }
);}




export const getSocialSettingsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialSettingsPartialUpdate>>, TError,{id: string;data: PatchedSocialSettingsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof socialSettingsPartialUpdate>>, TError,{id: string;data: PatchedSocialSettingsRequest}, TContext> => {

const mutationKey = ['socialSettingsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof socialSettingsPartialUpdate>>, {id: string;data: PatchedSocialSettingsRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  socialSettingsPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SocialSettingsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof socialSettingsPartialUpdate>>>
    export type SocialSettingsPartialUpdateMutationBody = PatchedSocialSettingsRequest
    export type SocialSettingsPartialUpdateMutationError = unknown

    export const useSocialSettingsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialSettingsPartialUpdate>>, TError,{id: string;data: PatchedSocialSettingsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof socialSettingsPartialUpdate>>,
        TError,
        {id: string;data: PatchedSocialSettingsRequest},
        TContext
      > => {

      const mutationOptions = getSocialSettingsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Reload the starting word lists (versioned data file).
 */
export type socialSettingsResetTermsCreateResponse200 = {
  data: SocialSettings
  status: 200
}
    
export type socialSettingsResetTermsCreateResponseSuccess = (socialSettingsResetTermsCreateResponse200) & {
  headers: Headers;
};
;

export type socialSettingsResetTermsCreateResponse = (socialSettingsResetTermsCreateResponseSuccess)

export const getSocialSettingsResetTermsCreateUrl = (id: string,) => {


  

  return `/api/v1/social/settings/${id}/reset-terms/`
}

export const socialSettingsResetTermsCreate = async (id: string, options?: RequestInit): Promise<socialSettingsResetTermsCreateResponse> => {
  
  return apiFetch<socialSettingsResetTermsCreateResponse>(getSocialSettingsResetTermsCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getSocialSettingsResetTermsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialSettingsResetTermsCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof socialSettingsResetTermsCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['socialSettingsResetTermsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof socialSettingsResetTermsCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  socialSettingsResetTermsCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SocialSettingsResetTermsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof socialSettingsResetTermsCreate>>>
    
    export type SocialSettingsResetTermsCreateMutationError = unknown

    export const useSocialSettingsResetTermsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof socialSettingsResetTermsCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof socialSettingsResetTermsCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getSocialSettingsResetTermsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    